import React from 'react';
import { Mail, Linkedin, Twitter, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <Mail className="w-5 h-5" />,
      label: "Email",
      href: "mailto:wm.design.ux@gmail.com"
    },
    {
      icon: <Linkedin className="w-5 h-5" />,
      label: "LinkedIn",
      href: "https://linkedin.com/in/wassimmhadhbi"
    },
    {
      icon: <ExternalLink className="w-5 h-5" />,
      label: "ComeUp",
      href: "https://comeup.com/fr/@kayti-creation"
    }
  ];

  const quickLinks = [
    { label: "Services", href: "#services" },
    { label: "Contact", href: "#contact" },
    { label: "Collaboration", href: "#collaboration" }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-t from-black to-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Footer Content */}
        <div className="py-12 grid md:grid-cols-4 gap-8">
          
          {/* Brand Section */}
          <div className="md:col-span-2 space-y-6">
            <div>
              <h3 className="text-2xl font-bold gradient-text mb-4">
                Wassim Mhadhbi
              </h3>
              <p className="text-gray-300 leading-relaxed max-w-md">
                UI/UX Designer passionné depuis 2014, spécialisé dans la création d'expériences digitales 
                exceptionnelles qui transforment vos idées en succès.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold text-white">Navigation</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-300 hover:text-[#DC1A5F] transition-colors duration-200 hover:underline"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold text-white">Contact</h4>
            <div className="space-y-3">
              <div className="text-gray-300">
                <p className="font-medium text-white">Email</p>
                <a 
                  href="mailto:wm.design.ux@gmail.com"
                  className="hover:text-[#DC1A5F] transition-colors duration-200"
                >
                  wm.design.ux@gmail.com
                </a>
              </div>
              <div className="text-gray-300">
                <p className="font-medium text-white">Plateforme</p>
                <a 
                  href="https://comeup.com/fr/@kayti-creation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#DC1A5F] transition-colors duration-200 flex items-center space-x-2"
                >
                  <span>ComeUp</span>
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} Wassim Mhadhbi. Tous droits réservés.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>UI/UX Designer depuis 2014</span>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-gradient-to-r from-[#DC1A5F] to-[#32D6E0] rounded-full animate-pulse"></div>
                <span>Disponible pour nouveaux projets</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;